import { NavLink } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react/components/shared/Icon";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useUnreadConversations } from "../hooks/useUnreadConversations";
import "../assets/styles/bottom-menu.css";

const navLinkClassNames = (isActive: boolean) =>
  classNames(
    {
      "text-default dark:text-feature-light": isActive,
      "text-disabled": !isActive,
    },
    "relative flex flex-col hover:text-default focus:text-default text-center",
  );

export const BottomMenu = () => {
  const { data } = useUnreadConversations();
  const unreadCount = data?.unread_count || 0;

  return (
    <div className="bg-primary text-darkest flex w-full items-center justify-between rounded-b-2xl px-6 pb-3 pt-2 text-[11px] font-medium leading-[18px] tracking-[0.2px]">
      <NavLink
        to="/"
        className={navLinkClassNames}
        isActive={(_match, location) => {
          const path = location.pathname;
          return (
            path === "/" ||
            path.endsWith("/new_ticket") ||
            path.startsWith("/message_confirmation/")
          );
        }}
      >
        <div className="mb-[-4px] p-1.5">
          <Icon type="sw-home" size={20} />
        </div>
        <span>{t("support_widget.bottom_menu.home")}</span>
      </NavLink>
      <NavLink to="/conversations" className={navLinkClassNames}>
        <div className="relative mb-[-4px] p-1.5">
          <Icon type="sw-conversations" size={20} />
          {unreadCount > 0 && (
            <div className="bg-v2-danger absolute right-[26px] top-[4px] size-2.5 rounded-lg" />
          )}
        </div>

        <span>{t("help_widget.bottom_menu.conversations")}</span>
      </NavLink>
      <NavLink
        to="/help"
        className={navLinkClassNames}
        isActive={(_match, location) => {
          const path = location.pathname;
          return (
            path === "/help" ||
            path.startsWith("/spaces/") ||
            path === "/space_groups" ||
            path.startsWith("/posts/")
          );
        }}
      >
        <div className="mb-[-4px] p-1.5">
          <Icon type="sw-help" size={20} />
        </div>
        <span>{t("support_widget.bottom_menu.help")}</span>
      </NavLink>
      <NavLink
        to="/explore"
        className={navLinkClassNames}
        isActive={(_match, location) => {
          const path = location.pathname;
          return (
            path === "/explore" ||
            path === "/events" ||
            path.startsWith("/news")
          );
        }}
      >
        <div className="mb-[-4px] p-1.5">
          <Icon type="sw-explore" size={20} />
        </div>
        <span>{t("help_widget.bottom_menu.explore")}</span>
      </NavLink>
    </div>
  );
};
